export enum StakeHolderId {
  NATURAL_MX = 1,
  JURIDICAL_MX = 2,
  NATURAL_FR = 3,
  JURIDICAL_FR = 4,
}

export interface IStakeHolderOptions {
  /** Translation key for the option value */
  value: string;
  /** Unique identifier for the option */
  key: string;
  /** Enum value that identifies the type of stakeholder */
  id: StakeHolderId;
}

/**
 * Props for the useEntityType hook
 */
export interface UseEntityTypeProps {
  /** The type of stakeholder being processed */
  personType: StakeHolderId;
}

/**
 * Return type for the useEntityType hook
 */
export interface UseEntityTypeReturn {
  /** Whether the stakeholder is a Mexican juridical person */
  isJuridicalMX: boolean;
  /** Whether the stakeholder is a foreign juridical person */
  isJuridicalFR: boolean;
  /** Whether the stakeholder is a Mexican natural person */
  isNaturalMX: boolean;
  /** Whether the stakeholder is a foreign natural person */
  isNaturalFR: boolean;
  /** Whether the stakeholder is any type of natural person */
  isNaturalPerson: boolean;
  /** Whether the stakeholder is any type of foreign person */
  isForeign: boolean;
  /** Whether the stakeholder is any type of Mexican person */
  isMexicanPerson: boolean;
  /** Whether the stakeholder is a juridical person */
  isJuridicalPerson: boolean;
  /** Function to get the select option for an entity type */
  getEntityTypeSelectOption: (
    selectedOption: IStakeHolderOptions['value'] | IStakeHolderOptions['id']
  ) => IStakeHolderOptions;
}

const STAKEHOLDER_OPTIONS: IStakeHolderOptions[] = [
  {
    value: 'regNaturalPersonMX',
    key: 'regNaturalPersonMX',
    id: StakeHolderId.NATURAL_MX,
  },
  {
    value: 'regJuridicalPersonMX',
    key: 'regJuridicalPersonMX',
    id: StakeHolderId.JURIDICAL_MX,
  },
  {
    value: 'regNaturalPersonForeigner',
    key: 'regNaturalPersonForeigner',
    id: StakeHolderId.NATURAL_FR,
  },
  {
    value: 'regJuridicalPersonForeigner',
    key: 'regJuridicalPersonForeigner',
    id: StakeHolderId.JURIDICAL_FR,
  },
];

export default STAKEHOLDER_OPTIONS;
